import React from 'react';

import { StyledAvatar } from './styles';
import useAvatarInitials from './useAvatarInitials';

export interface AvatarProps {
  size?: 'small' | 'medium' | 'large';
}

const Avatar: React.FC<AvatarProps> = ({
  size = 'medium',
  children,
  ...props
}) => {
  const avatarProps = useAvatarInitials(children);
  return <StyledAvatar size={size} {...avatarProps} {...props} />;
};

export default Avatar;
